import React, { useState } from "react";
import { Row, Col, Typography, QRCode } from "antd";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
import success from "asset/img/bailiff/success.png";
const PaymentSuccess = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Row gutter={[20, 20]}>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <Typography.Title level={4}>Thanh toán thành công</Typography.Title>
        <Typography.Text type="secondary">
          File này đã được thanh toán thành công, Chi tiết bên dưới
        </Typography.Text>
      </Col>
      <Col align="center" xl={24} lg={24} md={24} xs={24}>
        <img src={success} style={{ width: 200, height: 200 }} alt="success" />
      </Col>
    </Row>
  );
};
export default PaymentSuccess;
